<template>
  <b-modal
    id="alarm_action_modal"
    title="Alarma"
    @show="onShow"
    @hidden="resetDataModal"
    hide-header
    centered
    no-close-on-esc
    no-close-on-backdrop
    v-if="selectedAlarm"
  >
    <p class="w-100 lead border-bottom pb-50">
      <span v-if="selectedAlarm.action === 'confirmed'">
        {{ $t("grid.modals.alarms_status.title_confirm") }}
      </span>
      <span v-if="selectedAlarm.action === 'attended'">
        {{ $t("grid.modals.alarms_status.title_attended") }}
      </span>
      <span v-if="selectedAlarm.action === 'canceled'">
        {{ $t("grid.modals.alarms_status.title_cancel") }}
      </span>
      <span
        v-if="['send_to_review', 'return_to_attention'].includes(selectedAlarm.action)">
        Observaciones
      </span>
    </p>
    <div class="row">
      <div class="col-md-12">
        <validation-observer ref="refFormObserver">
          <validation-provider name="comments" rules="required" v-slot="{ errors }">
            <b-form-group
              :label="$t('grid.modals.alarms_status.protocol')"
              label-for="protocol"
              v-if="alarmCommentOptions.length"
            >
              <b-form-select
                v-model="alarmCommentSelected"
                :options="alarmCommentOptions"
              ></b-form-select>
            </b-form-group>
            <b-form-group
              :label="$t('grid.modals.alarms_status.comments')"
              label-for="comments"
            >
              <b-form-textarea
                id="comments"
                name="comments"
                placeholder=""
                rows="3"
                max-rows="6"
                v-model="comments"
              >
              </b-form-textarea>
              <span class="d-block mt-25 bg-none" v-if="errors.length > 0">
                {{ errors[0] }}
              </span>
            </b-form-group>
          </validation-provider>

          <!-- <b-form-group
              :label="$t('alarm.alarms')"
              label-for="alarms"
            >
            <div class="d-flex">
              <b-form-checkbox
                v-model="fromSameFacility"
                class="text-capitalize"
                switch
                @input="getAlarms"
              >
                {{ $t("grid.modals.alarms_status.fromSameFacility") }}
              </b-form-checkbox>
              <b-form-checkbox
                v-model="fromSameAlarmType"
                class="text-capitalize"
                switch
                @input="getAlarms"
              >
                {{ $t("grid.modals.alarms_status.fromSameAlarmType") }}
              </b-form-checkbox>
              <b-form-checkbox
                v-model="fromSameSector"
                class="text-capitalize"
                switch
                @input="getAlarms"
              >
                {{ $t("grid.modals.alarms_status.fromSameSector") }}
              </b-form-checkbox>
            </div>
          </b-form-group> -->
          <validation-provider
            name="alarms"
            rules="required"
            v-slot="{ errors }"
            v-if="!['send_to_review', 'return_to_attention'].includes(selectedAlarm.action)"
          >
            <b-form-group>
              <v-select
                id="alarms"
                v-model="alarmsSelected"
                :options="alarmsOptions"
                :clearable="false"
                input-id="alarms_select_cancel"
                :multiple="true"
                @search="onSearch"
              />
              <span class="d-block mt-25 bg-none" v-if="errors.length > 0">
                {{ errors[0] }}
              </span>
            </b-form-group>
          </validation-provider>

          <b-form-group
            :label="$t('grid.modals.alarms_status.alarm_level')"
            label-for="alarm_level"
            v-if="actionType.attending && alarmLevelOptions.length &&
            !['send_to_review', 'return_to_attention'].includes(selectedAlarm.action)"
          >
            <b-form-select
              v-model="alarmLevelSelected"
              :options="alarmLevelOptions"
            ></b-form-select>
          </b-form-group>
        </validation-observer>
      </div>
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="onCancel()" :disabled="loading">
        {{ $t("grid.modals.alarms_status.btns.cancel") }}
      </b-button>
      <b-button variant="primary" @click="submit()" :disabled="loading">
        {{ $t("grid.modals.alarms_status.btns.send") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BSpinner,
  BForm,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BButton,
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import ToastificationContent
  from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import axios from "axios";
import {EventBus} from "@/libs/event-bus";
import vSelect from "vue-select";
import {debounce} from "lodash";

export default {
  components: {
    BSpinner,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  data() {
    return {
      comments: "",
      loading: false,
      actionType: {},
      alarmLevelSelected: null,
      alarmCommentSelected: null,
      alarmLevelOptions: [],
      alarmCommentOptions: [],
      alarmUrlOptions: null,
      alarmsSelected: [],
      alarmsOptions: [],
      alarmsSearch: "",
      fromSameFacility: false,
      fromSameAlarmType: false,
      fromSameSector: false,
    };
  },
  computed: {
    selectedAlarm() {
      return store.state.grid.selectedAlarm;
    },
    locale() {
      return store.getters["user/getPreferences"].lang;
    },
  },
  methods: {
    onShow() {
      this.getAlarms();
      const currentAlarmSelected = {
        ...this.selectedAlarm.alarm,
        label: `${this.selectedAlarm.alarm?.alarm_acronym ?? ''} - ${this.selectedAlarm.alarm?.unit?.description ?? ''} - ${this.selectedAlarm.alarm?.detection_event_data?.camera_data?.camera?.name ?? ''}`,
        value: this.selectedAlarm.alarm.id
      }
      this.alarmsSelected = [currentAlarmSelected]

      const {action, alarm} = this.selectedAlarm;
      const {host, tenant, id_alarm_type} = alarm;

      const isAttending = ['confirmed', 'send_to_review', 'return_to_attention'].includes(action);

      this.actionType = {
        attending: isAttending,
        attended: action === 'attended',
        canceled: action === 'canceled',
        send_to_review: action === 'send_to_review',
        return_to_attention: action === 'return_to_attention',
      };

      const url = `${host}/v1/services/alarms/alarm-levels?id_tenant=${tenant.id}`;

      const queryParams = new URLSearchParams({
        id_tenant: tenant.id,
        'id_type_alarm[]': id_alarm_type
      });

      if (this.actionType.attending) queryParams.append('attending', '1');
      if (this.actionType.attended) queryParams.append('attended', '1');
      if (this.actionType.canceled) queryParams.append('canceled', '1');
      if (this.actionType.send_to_review) queryParams.append('send_to_review', '1');
      if (this.actionType.return_to_attention) queryParams.append('return_to_attention', '1');

      const commentUrl = `${host}/v1/alarm_comment?${queryParams.toString()}`;

      let token = localStorage.getItem("accessToken");

      if (this.selectedAlarm.alarm.host !== window.__env.VUE_APP_BASE_URL) {
        const externalUser = this.$store.state.user?.user?.external_users?.find(
          (external_user) => external_user.host === this.selectedAlarm.alarm.host
        );
        if (externalUser?.token) token = externalUser.token;
      }

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Host": this.selectedAlarm.alarm.host,
            "X-localization": this.locale,
          },
        })
        .then((resp) => {
          if (resp.data.data.length) {
            this.alarmLevelOptions.push({
              value: null,
              text: "Normal",
            });
            resp.data.data.forEach((item) =>
              this.alarmLevelOptions.push({value: item.level, text: item.description})
            );
            this.alarmLevelSelected = null;
          }
        });

      axios
        .get(commentUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Host": this.selectedAlarm.alarm.host,
            "X-localization": this.locale,
          },
        })
        .then((resp) => {
          if (resp.data.data.length) {
            resp.data.data.forEach((item) => this.alarmCommentOptions.push(item.comment));
            this.alarmCommentSelected = null;
          }
        });
    }, // end onShow
    async submit() {
      const validation = await this.$refs.refFormObserver.validate();

      if (validation) {
        this.alarmsSelected.forEach((alarm, index) => {
          setTimeout(() => {
            this.sendAlarmUpdate(alarm, index);
          }, 500);
        });
      }
    }, // end submit
    sendAlarmUpdate(alarm, index) {
      const idAlarm = alarm.id;
      const data = {
        id_alarm: idAlarm,
        attending: this.actionType.attending,
        attended: this.actionType.attended,
        canceled: this.actionType.canceled,
        send_to_review: this.actionType.send_to_review,
        return_to_attention: this.actionType.return_to_attention
      };

      if (data.attending) {
        data["attending_comments"] = this.comments;
        if (this.alarmLevelSelected) {
          data["id_alarm_level"] = this.alarmLevelSelected;
        }
      }

      if (this.alarmCommentSelected) {
        data["protocol"] = this.alarmCommentSelected;
      }

      if (data.attended) data["attended_comments"] = this.comments;
      if (data.attended) data["solved_comments"] = this.comments;
      if (data.canceled) data["cancel_comments"] = this.comments;
      if (data.send_to_review) data["send_to_review_comments"] = this.comments;
      if (data.return_to_attention) data["return_to_attention_comments"] = this.comments;

      this.loading = true;

      let token = localStorage.getItem("accessToken");

      if (this.selectedAlarm.alarm.host !== window.__env.VUE_APP_BASE_URL) {
        const externalUser = this.$store.state.user?.user?.external_users?.find(
          (external_user) => external_user.host === this.selectedAlarm.alarm.host
        );
        if (externalUser?.token) token = externalUser.token;
      }

      axios
        .post(`${this.selectedAlarm.alarm.host}/v1/services/alarms/update`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
            "X-Host": this.selectedAlarm.alarm.host,
            "X-localization": this.locale,
          },
        })
        .then(async (resp) => {
          if (data.attending) {
            if (index === 0) {
              this.showMessage(
                this.$t("notifications.alarm.updated_to_attending_success")
              );
            }
            EventBus.emit("alarm:attending", data.id_alarm);
          }
          if (data.attended) {
            if (index === 0) {
              this.showMessage(
                this.$t("notifications.alarm.updated_to_attended_success")
              );
            }
            EventBus.emit("alarm:attended", data.id_alarm);
          }
          if (data.canceled) {
            if (index === 0) {
              this.showMessage(
                this.$t("notifications.alarm.updated_to_canceled_success")
              );
            }
            EventBus.emit("alarm:canceled", data.id_alarm);
          }
          if (data.send_to_review || data.return_to_attention) {
            const action = data.send_to_review ? 'review' : 'restore';
            const commentsKey = data.send_to_review ? 'send_to_review_comments' : 'return_to_attention_comments';
            const workflowResponse = await this.takeOrReleaseAlarm(
              action,
              {id: data.id_alarm},
              {comments: data[commentsKey]}
            );

            if (workflowResponse?.success === false) {
              throw new Error(workflowResponse.message);
            }
          }

          if (this.selectedAlarm.slot && this.selectedAlarm.slot.pos) {
            store.dispatch("grid/updateSlotData", {
              pos: this.selectedAlarm.slot.pos,
              data: resp.data.data,
            });
          }

          store.dispatch("grid/removeVisited", {id: data.id_alarm, type: "alarm"});

          store.dispatch("grid/updateAlarms");
          this.closeModal();
        })
        .catch((error) => {
          if (index === 0) {
            this.showMessage(
              error.response?.data?.message || error.message || `${this.$t("notifications.alarm.updated_error")}: ${idAlarm}`,
              "danger"
            );
          }
        })
        .finally(() => (this.loading = false));
    }, // end sendAlarmUpdate
    showMessage(msg, variant = "success") {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.$t("notifications.alarm.updated_alarm_title"),
            variant,
            icon: "BellIcon",
            text: msg,
          },
        },
        {
          position: "top-right",
          timeout: 4000,
        }
      );
    },
    resetDataModal() {
      store.dispatch("grid/unsetSelectedAlarm");
      this.comments = "";
      this.alarmLevelOptions = [];
      this.alarmCommentOptions = [];
      this.alarmLevelSelected = null;
      this.alarmCommentSelected = null;
      this.alarmsSelected = [];
      this.fromSameAlarmType = false;
      this.fromSameFacility = false;
      this.fromSameSector = false;
    },
    closeModal() {
      this.resetDataModal();
      this.$bvModal.hide("alarm_action_modal");
    },
    onCancel() {
      this.closeModal();
    },
    getAlarms() {
      const url = `${window.__env.VUE_APP_MS_ALARMS_URL}`
      const params = {
        max: 5,
        filter: this.selectedAlarm.alarm.alarm_status,
        q: this.alarmsSearch
      }
      if (this.fromSameFacility) {
        params.id_facility = this.selectedAlarm.alarm?.unit?.id
      }
      if (this.fromSameAlarmType) {
        params.id_alarm_type = this.selectedAlarm.alarm?.id_alarm_type
      }
      if (this.fromSameSector) {
        params.id_sector = this.selectedAlarm.alarm?.unit?.id_sector
      }
      const token = localStorage.getItem("accessToken");
      const source = axios.CancelToken.source();

      axios.get(url, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Host": this.selectedAlarm.alarm.host,
        },
        cancelToken: source.token,
      })
        .then((resp) => {
          this.alarmsOptions = resp.data.data.map(item => ({
            ...item,
            label: `${item?.alarm_acronym ?? ''} - ${item?.unit?.description ?? ''} - ${item?.detection_event_data?.camera_data?.camera?.name ?? ''}`,
            value: item.id,
          }))
        })
    },
    onSearch: debounce(async function (query, loading) {
      this.alarmsSearch = query;
      this.getAlarms();
    }, 800),
    async takeOrReleaseAlarm(action, item, data = {}) {
      if (this.$can("user_alarms", "Workspace")) {
        const payload = {
          id_alarm: item.id,
          action,
          data,
        };
        await store.dispatch("taken_alarms/takeAlarm", payload);
      }
    },
  },
};
</script>

<style>
.bg-none {
  background: none !important;
  color: var(--secondary) !important;
}
</style>
